import { Input, HostBinding, Component, ElementRef, Renderer2 } from '@angular/core';
export type ButtonGroupSize = 'small' | 'default' | 'large';

@Component({
  selector: 'bp-button-group, bp-btn-group',
  exportAs: 'bpButtonGroup',
  template: `<ng-content></ng-content>`
})
export class BpButtonGroupComponent {
  @Input() vertical = false;
  @Input() size: ButtonGroupSize = 'default';

  @HostBinding('class') public get _class() {
    let cls: string;
    if (this.vertical) {
      cls = 'btn-group-vertical';
    } else {
      cls = 'btn-group';
    }

    if (this.size === 'large') {
      cls += ' btn-group-lg';
    } else if (this.size === 'small') {
      cls += ' btn-group-sm';
    }

    return cls;
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'group');
  }
}
